export const notFound = {
  heading: '이 페이지는 생성되지 않았습니다',
  description: '이 페이지에 대해 자세히 알려주시면 생성해 드리겠습니다',
};
